import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { trackAddToCart, trackInitiateCheckout } from '../utils/metaPixel';
const CART_URL = 'https://checkout.volveaserdeseada.com/cart/add?id=42732657344599&quantity=1&return_to=%2Fcart';
export function Guarantee() {
  return <section className="py-12 md:py-16 px-6" data-id="element-64">
      <div className="max-w-2xl mx-auto" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-66">
          {/* Icon — soft, integrated */}
          <div className="flex items-center justify-center mb-6" data-id="element-67">
            <div className="w-14 h-14 rounded-full bg-burgundy/10 flex items-center justify-center" data-id="element-68">
              <ShieldCheckIcon className="w-7 h-7 text-burgundy" strokeWidth={1.5} data-id="element-69" />
            </div>
          </div>

          {/* Eyebrow */}
          <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-burgundy/60 mb-4 font-medium" data-id="element-70">
            Garantía 7 días
          </p>

          {/* Editorial heading */}
          <h2 className="font-playfair text-[26px] md:text-3xl lg:text-4xl font-light text-burgundy leading-tight mb-6" data-id="element-71">
            Probalo sin riesgo.
            <br data-id="element-72" />
            <span className="italic" data-id="element-73">Sentí el cambio.</span>
          </h2>

          {/* Subtle gold divider */}
          <div className="w-12 h-px bg-gold/60 mx-auto mb-8" data-id="element-74" />

          {/* Editorial body — flowing prose, not a card */}
          <div className="space-y-5 text-charcoal/75 leading-relaxed text-[15px] md:text-base max-w-lg mx-auto" data-id="element-75">
            <p data-id="element-76">
              Tenés 7 días completos para leerlo, aplicarlo y sentir cómo
              empezás a recuperar la conexión, la seguridad y el deseo.
            </p>
            <p data-id="element-77">
              Si en ese tiempo sentís que no es para vos, te devolvemos tu
              dinero.{' '}
              <span className="italic text-burgundy/80" data-id="element-78">
                Sin vueltas, sin explicaciones incómodas.
              </span>
            </p>
          </div>

          {/* Subtle gold divider */}
          <div className="w-12 h-px bg-gold/60 mx-auto my-8" data-id="element-79" />

          {/* Final emotional line */}
          <p className="font-playfair italic text-burgundy text-lg md:text-xl mb-8 leading-relaxed" data-id="element-80">
            Comprás sin riesgo.
            <br data-id="element-81" />
            Decidís con seguridad.
          </p>

          {/* Mini emotional CTA */}
          <motion.button initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} onClick={() => {
          trackAddToCart();
          trackInitiateCheckout();
          window.location.href = CART_URL;
        }} className="inline-flex items-center gap-2 text-burgundy font-semibold text-base md:text-lg border-b border-burgundy/40 pb-1 hover:border-burgundy hover:gap-3 transition-all" data-id="element-82">
            Quiero recuperar la conexión
            <span className="transition-transform" data-id="element-83">→</span>
          </motion.button>
        </motion.div>
      </div>
    </section>;
}